import styled from "styled-components";

export const ThemeSelectContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10rem;

    @media (max-width: 768px) {
        gap: 1.5rem;
    }
`;
